import { FC, ReactElement, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'

import { LeaveOfAbsenceDetailContainer } from '@/containers'
import { trans } from '@/helpers/trans'
import { cancelLeaveOfAbsence, fetchLeaveOfAbsencesDetail } from '@/redux/leaveOfAbsenceRequestDetail/leaveOfAbsenceRequestDetailActions'
import { useTypedDispatch, useTypedSelector } from '@/redux/store'

export const ConnectedLeaveOfAbsenceDetail: FC = (): ReactElement => {
    const navigate = useNavigate()
    const { id = '' } = useParams<{ id: string }>()

    const dispatch = useTypedDispatch()

    const { leaveOfAbsenceRequestDetail, isLoading } = useTypedSelector(state => state.pacoLeaveOfAbsenceRequestDetailReducer)

    const cancelLeaveOfAbsenceHandler = (leaveOfAbsenceId: string) => {
        dispatch(cancelLeaveOfAbsence(leaveOfAbsenceId))

        navigate(`/${trans('nav.absences.link')}/${trans('nav.leaveOfAbsenceRequests.link')}`)
    }

    useEffect(() => {
        dispatch(fetchLeaveOfAbsencesDetail(id))
    }, [id])

    return (
        <LeaveOfAbsenceDetailContainer
            cancelLeaveOfAbsence={() => cancelLeaveOfAbsenceHandler(id)}
            leaveOfAbsence={leaveOfAbsenceRequestDetail}
            isLoading={isLoading}
        />
    )
}
